export default __webpack_public_path__ + "static/media/send.fab9d966.svg";